<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i :class="provider.id == null ? 'bi bi-truck' : 'bi bi-pencil'"></i>
              {{ provider.id == null ? 'Nuevo proveedor' : 'Editar proveedor' }}
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
          <div class="modal-body form-card form-card--bare">
            <div class="form-card__field">
              <label class="form-card__label" for="provider-iva">Tipo de IVA</label>
              <q-select v-model="provider.iva_type" :options="ivaTypeOptions" placeholder="- Seleccionar tipo de IVA -" />
              <div class="form-card__hint">Obligatorio. Definí el tipo antes de continuar.</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-cuit">CUIT / DNI</label>
              <div class="d-flex" style="gap: 8px;">
                <input id="provider-cuit" v-model.trim="provider.cuit" type="text" class="form-control" placeholder="CUIT / DNI" :class="{ 'is-invalid': codigoValido === false }" :disabled="!provider.iva_type">
                <button
                  type="button"
                  class="form-card__btn form-card__btn--primary"
                  :disabled="!provider.iva_type || !provider.cuit || provider.cuit.length !== 11"
                  @click="getAfipProviderData()"
                >
                  <i class="bi bi-cloud-download"></i>
                  ARCA
                </button>
              </div>
              <div class="form-card__hint">Consultá el CUIT en ARCA y completá el formulario.</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-name">Nombre del proveedor</label>
              <input id="provider-name" v-model.trim="provider.name" type="text" class="form-control" placeholder="Nombre del proveedor" :disabled="!provider.iva_type">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-business">Razón social</label>
              <input id="provider-business" v-model.trim="provider.business" type="text" class="form-control" placeholder="Razón social" :disabled="!provider.iva_type">
            </div>
            
            <div class="form-card__field">
              <label class="form-card__label" for="provider-phone1">Teléfono</label>
              <input id="provider-phone1" v-model.trim="provider.phone_1" type="text" class="form-control" placeholder="Teléfono">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-phone2">Teléfono celular</label>
              <input id="provider-phone2" v-model.trim="provider.phone_2" type="text" class="form-control" placeholder="Teléfono celular">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-email">E-mail</label>
              <input id="provider-email" v-model.trim="provider.email" type="email" class="form-control" placeholder="E-mail">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-address">Dirección</label>
              <input id="provider-address" v-model.trim="provider.address" type="text" class="form-control" placeholder="Dirección">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-province">Provincia</label>
              <q-select v-model="provider.province" :options="provinceOptions" placeholder="- Seleccionar -" />
              <div class="form-card__hint">Campo obligatorio</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-city">Localidad</label>
              <input id="provider-city" v-model.trim="provider.city" type="text" class="form-control" placeholder="Localidad">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-postalcode">Código postal</label>
              <input id="provider-postalcode" v-model.trim="provider.postalcode" type="text" class="form-control" placeholder="Código postal">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="provider-notes">Observaciones</label>
              <textarea id="provider-notes" v-model="provider.notes" class="form-control" rows="3"></textarea>
            </div>
          </div>
          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close">Cancelar</button>
            <button type="button" class="form-card__btn form-card__btn--primary" :disabled="isSaving" @click="saveProvider()">
              <i class="bi bi-check-lg"></i>
              {{ provider.id == null ? 'Agregar proveedor' : 'Actualizar proveedor' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import QSelect from '@/components/shared/QSelect.vue';

const PROVINCES = [
  { value: 'Capital Federal', text: 'CABA' },
  { value: 'Buenos Aires', text: 'Buenos Aires' },
  { value: 'Catamarca', text: 'Catamarca' },
  { value: 'Chaco', text: 'Chaco' },
  { value: 'Chubut', text: 'Chubut' },
  { value: 'Corrientes', text: 'Corrientes' },
  { value: 'Cordoba', text: 'Córdoba' },
  { value: 'Entre Rios', text: 'Entre Ríos' },
  { value: 'Formosa', text: 'Formosa' },
  { value: 'Jujuy', text: 'Jujuy' },
  { value: 'La Pampa', text: 'La Pampa' },
  { value: 'La Rioja', text: 'La Rioja' },
  { value: 'Mendoza', text: 'Mendoza' },
  { value: 'Misiones', text: 'Misiones' },
  { value: 'Neuquen', text: 'Neuquen' },
  { value: 'Rio Negro', text: 'Río Negro' },
  { value: 'Salta', text: 'Salta' },
  { value: 'San Juan', text: 'San Juan' },
  { value: 'San Luis', text: 'San Luis' },
  { value: 'Santa Cruz', text: 'Santa Cruz' },
  { value: 'Santa Fe', text: 'Santa Fe' },
  { value: 'Santiago del Estero', text: 'Santiago del Estero' },
  { value: 'Tierra del Fuego', text: 'Tierra del Fuego' },
  { value: 'Tucuman', text: 'Tucumán' },
];

const emptyProvider = () => ({
  id: null,
  name: "",
  code: null,
  address: null,
  phone_1: null,
  phone_2: null,
  email: null,
  cuit: null,
  iva_type: null,
  business: null,
  postalcode: null,
  city: null,
  province: null,
  notes: null,
  t_linked: null,
});

export default {
  components: { QSelect },
  props: ['providerId'],
  data() {
    return {
      provider: emptyProvider(),
      isSaving: false,
      provinces: PROVINCES,
      optionsUnit: [
        { value: 'Consumidor Final', text: 'Consumidor Final' },
        { value: 'Responsable Inscripto', text: 'Responsable Inscripto' },
        { value: 'Exento', text: 'Exento' },
        { value: 'Monotributo', text: 'Monotributo' },
      ],
    };
  },
  mounted() {
    this.providerIdExist();
  },
  methods: {
    providerIdExist() {
      if (this.providerId != null) {
        this.getProvider(this.providerId);
      } else {
        this.resetForm();
      }
    },
    getProvider(id) {
      this.$http.get('/api/providers/getProvider/' + id).then((response) => {
        this.provider = response.data.data;
      });
    },
    saveProvider() {
      if (this.isSaving) return;
      this.isSaving = true;
      if (this.provider.cuit) {
        this.provider.cuit = String(this.provider.cuit).replace(/\D/g, '');
      }
      const isEdit = this.provider.id != null;
      const url = isEdit
        ? '/api/providers/edit/' + this.provider.id
        : '/api/providers/add';
      this.$http.post(url, this.provider).then(() => {
        this.resetForm();
        this.$emit('confirmsave');
        this.$emit('close');
      }).finally(() => {
        this.isSaving = false;
      });
    },
    resetForm() {
      this.provider = emptyProvider();
    },
    close() {
      this.$emit('close');
    },
    getAfipProviderData() {
      this.$http.get('/api/clients/getAfipClientData/' + this.provider.cuit).then((response) => {
        if (response.data.success !== true) return;
        const afipData = response.data.data;
        this.provider.cuit = afipData.cuit;
        this.provider.name = afipData.nombre;
        this.provider.business = afipData.razonSocial;
        this.provider.address = afipData.domicilios[0].direccion;
        this.provider.city = afipData.domicilios[0].localidad;
        this.provider.province = afipData.domicilios[0].descripcionProvincia;
        this.provider.postalcode = afipData.domicilios[0].codigoPostal;
      });
    },
  },
  computed: {
    codigoValido() {
      return isNaN(this.provider.code) ? false : null;
    },
    ivaTypeOptions() {
      return this.optionsUnit.map(opt => ({ value: opt.value, label: opt.text }));
    },
    provinceOptions() {
      return this.provinces.map(prov => ({ value: prov.value, label: prov.text }));
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
